/**
 * Emits footstep events from movement cadence (no audio required).
 */

/** @typedef {{ index: number; speed: number; sprinting: boolean }} FootstepEvent */

export class FootstepController {
  /**
   * @param {{
   *   minSpeed?: number;
   *   onFootstep?: (payload: FootstepEvent) => void;
   * }} [options]
   */
  constructor({
    minSpeed = 0.6,
    cadence = 1.75,
    sprintCadence = 2.35,
    onFootstep = null,
  } = {}) {
    this.minSpeed = minSpeed;
    this.cadence = cadence;
    this.sprintCadence = sprintCadence;
    /** @type {((payload: FootstepEvent) => void) | null} */
    this.onFootstep = onFootstep;
    this._stepIndex = 0;
    this._phase = 0;
  }

  /**
   * @param {{
   *   horizontalSpeed: number;
   *   onGround: boolean;
   *   sprinting: boolean;
   *   delta: number;
   * }} state
   */
  update({ horizontalSpeed, onGround, sprinting, delta }) {
    if (!onGround || horizontalSpeed < this.minSpeed) {
      this._phase = 0;
      return;
    }

    const stepCadence = sprinting ? this.sprintCadence : this.cadence;
    const prevCycle = Math.floor(this._phase / Math.PI);
    this._phase += horizontalSpeed * stepCadence * delta;
    const nextCycle = Math.floor(this._phase / Math.PI);

    if (nextCycle > prevCycle) {
      this._stepIndex += 1;
      const payload = {
        index: this._stepIndex,
        speed: horizontalSpeed,
        sprinting,
      };
      if (this.onFootstep) this.onFootstep(payload);
    }
  }
}
